import React from 'react';
import { connect } from 'react-redux';
import {
  VictoryChart,
  VictoryBar,
  VictoryAxis,
  VictoryStack,
  VictoryLabel,
} from 'victory';
import { getTenantState } from '../../../store/selectors';
import BoxSecondaryUnderline from '../basic-style-components/BoxSecondaryUnderline';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';
import Chevron from '../../user-dashboard/utility/Chevron';

export class TopChosenChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
      detailsButtonLabel: 'Details',
      detailsArrowRotate: 'rotate(90deg)',
    };
  }

  setShowDetails = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showDetails: !prevState.showDetails,
        detailsButtonLabel: !prevState.showDetails ? 'Close' : 'Details',
        detailsArrowRotate: !prevState.showDetails
          ? 'rotate(270deg)'
          : 'rotate(90deg)',
      };
    });
  };

  details() {
    const detailsLegend = {};
    let counter = 0;
    Object.entries(this.props.data).map(([educationLevel, count]) => {
      detailsLegend[educationLevel] =
        reportingCopy.topChosen.fullColorScale[counter];
      counter++;
    });

    return (
      <div className="top-chosen-chart__details">
        {Object.entries(this.props.data).map(([educationLevel, count]) => {
          return (
            <div
              className="top-chosen-chart__details-item"
              key={educationLevel}
            >
              <div
                className="top-chosen-chart__details-color-square"
                style={{
                  backgroundColor: detailsLegend[educationLevel],
                }}
              />
              <div className="top-chosen-chart__details-label">
                {`${educationLevel} (${count})`}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <BoxSecondaryUnderline tenant={this.props.tenant}>
        <div className="top-chosen-chart">
          <div className="top-chosen-chart__header">
            <div className="top-chosen-chart__heading">
              {this.props.category}
            </div>
          </div>
          <VictoryChart width={1300} height={60} padding={0}>
            <VictoryStack
              colorScale={reportingCopy.topChosen.fullColorScale}
              horizontal
              labels={({ datum }) => datum._y1}
              style={{
                labels: { fontWeight: 'bold', fontFamily: 'Roboto' },
              }}
              /* eslint-disable */
              labelComponent={
                <VictoryLabel
                  dy={-25}
                  dx={({ datum }) => -10 * datum._y1.toString().length}
                />
              }
              /* eslint-enable */
            >
              {Object.entries(this.props.data).map(([category, count]) => {
                return (
                  <VictoryBar
                    barWidth={30}
                    data={[{ x: 'a', y: count }]}
                    key={category}
                  />
                );
              })}
            </VictoryStack>
            <VictoryAxis
              style={{
                axis: { stroke: 'transparent' },
                ticks: { stroke: 'transparent' },
                tickLabels: { fill: 'transparent' },
              }}
            />
          </VictoryChart>
          <div className="top-chosen-chart__details-container">
            {this.state.showDetails ? this.details() : null}
            <div className="top-chosen-chart__details-button-container">
              <button
                className="top-chosen-chart__details-button"
                type="button"
                onClick={() => this.setShowDetails()}
              >
                {this.state.detailsButtonLabel}
                <Chevron
                  transform={this.state.detailsArrowRotate}
                  ariaLabel={`Click to ${
                    this.state.detailsButtonLabel === 'Details'
                      ? 'view details'
                      : 'close'
                  }`}
                />
              </button>
            </div>
          </div>
        </div>
      </BoxSecondaryUnderline>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps)(TopChosenChart);
